import api from "@/api";
import { config } from "@/constants/index";

const ADD_CUSTOMER_CARD_TRANSACTIONS = "ADD_CUSTOMER_CARD_TRANSACTIONS";
const ADD_CUSTOMER_CARD_TRANSACTIONS_PAGE =
  "ADD_CUSTOMER_CARD_TRANSACTIONS_PAGE";

export default {
  namespaced: true,
  state: {
    all: {},
    paginator: {},
    nbPages: 1,
  },
  getters: {
    cardTransactionsPage: ({ all, paginator }) => page => {
      if (!paginator[page]) {
        return [];
      }

      return paginator[page].map(id => all[id]).filter(t => !!t);
    },
    cardTransactionsNbPages: ({ nbPages }) => nbPages,
  },
  actions: {
    async getCardTransactionsPage({ commit }, { id, page }) {
      let res = await api.cardTransaction.all(id, {
        page,
        itemsPerPage: config.maxPerPage,
      });

      commit(ADD_CUSTOMER_CARD_TRANSACTIONS, res.data["hydra:member"]);
      commit(ADD_CUSTOMER_CARD_TRANSACTIONS_PAGE, {
        nbPages: Math.ceil(res.data["hydra:totalItems"] / config.maxPerPage),
        items: res.data["hydra:member"],
        page: page,
      });

      return res;
    },
  },
  mutations: {
    [ADD_CUSTOMER_CARD_TRANSACTIONS](state, transactions) {
      transactions.forEach(transaction => {
        state.all = Object.assign({}, state.all, {
          [transaction.id]: transaction,
        });
      });
    },
    [ADD_CUSTOMER_CARD_TRANSACTIONS_PAGE](state, { items, page, nbPages }) {
      if (!items.length) {
        return;
      }

      state.nbPages = nbPages;
      state.paginator = Object.assign({}, state.paginator, {
        [page]: items.map(item => item.id),
      });
    },
  },
};
